import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import Blog_Banner from "./blog-banner/Blog_Banner";
import Inner_Description from "./inner-description/Inner_Description";
import Popular_Tags from "./popular-tags/Popular_Tags";
import Conclusion from "./conclusion/Conclusion";
import Explore_Blogs from "./explore-blogs/Explore_Blogs";
import Free_Consultation from "../../home/free-consultation/Free_Consultation";

const Blog_Inner_Page = () => {

  const { id } = useParams();


  return (
    <>
      {/* Banner */}
      <div >
        <Blog_Banner />
      </div>

      <div className="container">
        <div className="row justify-content-center">

          {/* Left Side Content */}
          <div className="col-lg-7">

            <div >
              <Inner_Description blogId={id} />
            </div>

            <div >
              <Conclusion blogId={id} />
            </div>

            <div >
              <Free_Consultation />
            </div>

          </div>

          {/* Right Side Content */}
          <div className="col-lg-5 px-4">

            <div >
              <Popular_Tags blogId={id} />
            </div>

            <div >
              <Explore_Blogs blogId={id} />
            </div>

          </div>

        </div>
      </div>
    </>
  );
};

export default Blog_Inner_Page;